module.exports = __webpack_public_path__ + "img/073.6ebffc1d.png";